export class AutoAddress {
  constructor() {
    this.DOM = {};

    // 検索トリガー（ボタン）
    this.DOM.trigger = document.querySelector('[data-autoaddress-trigger]');
    if (!this.DOM.trigger) return;

    // 郵便番号入力欄（トリガーの近く、またはフォーム内から取得）
    this.DOM.form = this.DOM.trigger.closest('form');
    this.DOM.zipInput = this.DOM.form ? this.DOM.form.querySelector('[data-autoaddress-zip] input[name="zip"]') : null;

    // ターゲット要素の取得
    this.DOM.prefSelect = document.querySelector('[data-autoaddress-target="prefecture"] select');
    this.DOM.cityInput = document.querySelector('[data-autoaddress-target="city"] input');
    this.DOM.streetInput = document.querySelector('[data-autoaddress-target="street"] input');

    // CF7のメッセージ出力枠
    this.DOM.cf7Response = this.DOM.form ? this.DOM.form.querySelector('.wpcf7-response-output') : null;

    // クラス名・データ属性の定義（Validationクラスと統一）
    this.CLASS = {
      HAS_ERROR: 'has-error',
      ERROR_MESSAGE: 'c-error'
    };
    this.DATA_ATTR = {
      ERROR_MESSAGE: 'data-validation-error-message'
    };

    this.init();
  }

  init() {
    this.bindEvents();
  }
bindEvents() {
    // 1. ボタンクリック時
    this.DOM.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }

      // 万が一CF7の出力エリアがアクティブになっていたら消去・非表示化
      this.hideCF7Response();

      this.fetchAddress();
      return false;
    }, true);

    // 郵便番号入力時のエラー消去
    if (this.DOM.zipInput) {
      this.DOM.zipInput.addEventListener('input', () => {
        const parent = this.DOM.zipInput.closest('.l-entry__formItem');
        if (parent) {
          this.clearError(parent, this.DOM.zipInput);
        }
      });
    }
  }

  async fetchAddress() {
    if (!this.DOM.zipInput) return;

    const parent = this.DOM.zipInput.closest('.l-entry__formItem');
    const zipVal = this.DOM.zipInput.value.replace(/-/g, '').trim();

    if (!zipVal) return;

    try {
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipVal}`);
      const data = await response.json();

      if (data.status === 200 && data.results) {
        if (parent) {
          this.clearError(parent, this.DOM.zipInput);
        }

        const result = data.results[0];
        
        // 住所値をセット
        this.setValue(this.DOM.prefSelect, result.address1);
        this.setValue(this.DOM.cityInput, result.address2);
        this.setValue(this.DOM.streetInput, result.address3);

        // 念のためセット後もCF7出力を隠す
        this.hideCF7Response();

      } else {
        if (parent) {
          this.showError(parent, this.DOM.zipInput, '該当する住所が見つかりませんでした。');
        }
      }
    } catch (error) {
      if (parent) {
        this.showError(parent, this.DOM.zipInput, '住所の自動取得に失敗しました。');
      }
    }
  }
  /**
   * CF7のレスポンス出力をクリアする（クラスは削除しない）
   */
  hideCF7Response() {
    if (this.DOM.cf7Response) {
      // style.display や classList.remove は削除し、中身のテキストだけクリアする
      this.DOM.cf7Response.textContent = '';
      this.DOM.cf7Response.style.display = 'none'; // ※もし初期状態で隠したい場合のみ
    }
  }

  /**
   * 値をセットし、Validationクラスに通知
   */
  setValue(element, value) {
    if (!element) return;

    if (element.tagName === 'SELECT') {
      const options = Array.from(element.options);
      const targetOption = options.find((opt) => opt.text === value || opt.value === value);
      if (targetOption) {
        element.value = targetOption.value;
      }
    } else {
      element.value = value;
    }

    // ★CF7（form要素）までバブリングさせず、element自体に直接イベントを発火させてValidationクラスへ通知
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * エラー表示の追加
   */
  showError(parent, input, message) {
    if (input) input.classList.add(this.CLASS.HAS_ERROR);

    let errorEl = parent.querySelector(`[${this.DATA_ATTR.ERROR_MESSAGE}]`);

    if (!errorEl) {
      errorEl = document.createElement('span');
      errorEl.className = this.CLASS.ERROR_MESSAGE;
      errorEl.setAttribute(this.DATA_ATTR.ERROR_MESSAGE, '');
      parent.appendChild(errorEl);
    }
    errorEl.textContent = message;
  }

  /**
   * エラー表示の削除
   */
  clearError(parent, input) {
    if (input) input.classList.remove(this.CLASS.HAS_ERROR);

    const errorEl = parent.querySelector(`[${this.DATA_ATTR.ERROR_MESSAGE}]`);
    if (errorEl) {
      errorEl.remove();
    }
  }
}
